<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    // [{ title, fields: [{ key, label, prop? }] }] — labels already translated by the parent.
    // A field with `prop` binds to value[prop] (default OFF); otherwise to
    // value.visibleFields[key] (default ON).
    sections: {
      type: Array,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    fieldChecked(field) {
      if (field.prop) return !!this.value[field.prop];
      return this.value?.visibleFields?.[field.key] !== false;
    },
    setField(field, checked) {
      if (field.prop) {
        this.$emit("input", {
          ...this.value,
          [field.prop]: !!checked,
        });
        return;
      }
      this.$emit("input", {
        ...this.value,
        visibleFields: {
          ...(this.value.visibleFields || {}),
          [field.key]: !!checked,
        },
      });
    },
  },
};
</script>
<template>
  <span class="config-host">
    <button
      class="icon-btn"
      :class="{ 'icon-btn-sm': small }"
      @click.stop="open"
      :title="$t('general.filters')"
    >
      <i class="mdi mdi-cog-outline"></i>
    </button>
    <div class="overlay" v-if="isOpen" @click.self="close">
      <div class="sheet">
        <div class="top">
          <div class="spacer"></div>
          <div class="shandle"></div>
          <h4 role="button" @click="close">x</h4>
        </div>
        <div class="stitle">
          <i class="mdi mdi-cog-outline"></i>
          {{ $t("general.filters") }}
        </div>
        <div class="config-selection">
          <div class="csection" v-for="(section, sIdx) in sections" :key="sIdx">
            <div class="ssec">{{ section.title }}</div>
            <div class="ftog-list">
              <div class="ftog" v-for="f in section.fields" :key="f.key">
                <span>{{ f.label }}</span>
                <b-form-checkbox
                  switch
                  :checked="fieldChecked(f)"
                  @change="setField(f, $event)"
                />
              </div>
            </div>
          </div>
        </div>
        <button class="sclosebtn" @click="close">
          {{ $t("general.confirm") }}
        </button>
      </div>
    </div>
  </span>
</template>
<style scoped>
.config-host {
  display: contents;
}
.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: 1px solid #e0e5ea;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7a8a99;
  font-size: 17px;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  padding: 0;
}
.icon-btn:hover {
  border-color: #1c2e3e;
  color: #1c2e3e;
}
.icon-btn-sm {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  font-size: 14px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.sheet {
  display: flex;
  flex-direction: column;
  background: white;
  width: 100%;
  max-width: 600px;
  border-radius: 20px 20px 0 0;
  padding: 14px;
  max-height: 85vh;
}
.top {
  display: flex;
  justify-content: center;
}
.config-selection{
  overflow-y: auto;
}
.shandle {
  width: 34px;
  height: 4px;
  background: #e0e5ea;
  border-radius: 2px;
  margin: 0 auto 12px;
}
.stitle {
  font-size: 14px;
  font-weight: 700;
  color: #1c2e3e;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 7px;
}
.ssec {
  font-size: 10px;
  font-weight: 600;
  color: #7a8a99;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin: 10px 0 5px;
  padding: 0 2px;
}
.ftog-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ftog {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 11px;
  background: #f4f6f8;
  border-radius: 9px;
  border: 1px solid #e0e5ea;
  font-size: 12px;
  color: #1c2e3e;
}
.sclosebtn {
  width: 100%;
  margin-top: 12px;
  padding: 11px;
  background: #1c2e3e;
  color: white;
  border: none;
  border-radius: 11px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
</style>
